import { useEffect } from "react";
import { useUi } from "../state/ui";

const AUTO_DISMISS_MS = 15_000;

export function SpotlightBanner() {
  const invite = useUi((state) => state.spotlightInvite);
  const setInvite = useUi((state) => state.setSpotlightInvite);
  const setCamera = useUi((state) => state.setCamera);
  const setSelection = useUi((state) => state.setSelection);
  const setFollowing = useUi((state) => state.setFollowing);

  useEffect(() => {
    if (!invite) return;
    const timeout = setTimeout(() => setInvite(null), AUTO_DISMISS_MS);
    return () => clearTimeout(timeout);
  }, [invite, setInvite]);

  if (!invite) return null;

  return (
    <div className="banner">
      <span className="dot" style={{ background: invite.color }} />
      <span>
        <b style={{ fontWeight: 500 }}>{invite.fromName}</b> möchte dir etwas zeigen
      </span>
      <button
        onClick={() => {
          setCamera(invite.camera);
          if (invite.blockIds.length) setSelection(invite.blockIds);
          setInvite(null);
        }}
      >
        Hinspringen
      </button>
      <button
        onClick={() => {
          setFollowing(invite.fromId);
          setInvite(null);
        }}
      >
        Folgen
      </button>
      <button className="ghost" onClick={() => setInvite(null)}>
        Später
      </button>
    </div>
  );
}
